import { useState, useEffect } from 'react';

/**
 * Hook to detect current Tailwind breakpoint
 * Returns: 'extra_small' | 'small' | 'medium' | 'large' | 'extra_large'
 * 
 * Tailwind breakpoints:
 * - extra_small: < 640px (default, no prefix)
 * - small: >= 640px (sm:)
 * - medium: >= 768px (md:)
 * - large: >= 1024px (lg:)
 * - extra_large: >= 1280px (xl:)
 */
const useBreakpoint = () => {
  const getBreakpoint = () => {
    const width = window.innerWidth;
    
    if (width >= 1280) return 'extra_large';
    if (width >= 1024) return 'large';
    if (width >= 768) return 'medium';
    if (width >= 640) return 'small';
    return 'extra_small';
  };

  const [breakpoint, setBreakpoint] = useState(getBreakpoint());

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint());
    };

    // Debounce resize events for performance
    let timeoutId;
    const debouncedHandleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleResize, 150);
    };

    window.addEventListener('resize', debouncedHandleResize);
    
    // Initial check
    handleResize();

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  return breakpoint;
};

export default useBreakpoint;

